export var createMuiInputAdornmentOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        root: {
            height: undefined,
            maxHeight: undefined,
            fontSize: "inherit",
            lineHeight: 1.4,
            color: palette.text.secondary,
        },
        positionStart: {
            marginRight: undefined,
            paddingLeft: spacing(4),
            "&$marginDense": {
                paddingLeft: spacing(2),
            },
            // Input with a label and adornments
            "[class*='MuiInputLabel-root'] + [class*='MuiInputBase-root'] > &": {
                alignSelf: "flex-end",
                paddingBottom: spacing(2),
                "&$marginDense": {
                    paddingBottom: spacing(2) - 1, // Compensating for the border
                },
            },
        },
        positionEnd: {
            marginLeft: undefined,
            paddingRight: spacing(4),
            "&$marginDense": {
                paddingRight: spacing(2),
            },
            "[class*='MuiSelect-root'] ~ &": {
                paddingRight: "unset",
                position: "absolute",
                right: spacing(11),
            },
        },
    });
};
//# sourceMappingURL=MuiInputAdornment.js.map